import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment-timezone';
import {
    Table,
    Card,
    CardBody,
    CustomInput,
} from 'reactstrap';

import { surveyApi, selectSurveyByAreaId, setSorting, setFilters, removeAllSurvey } from '../../reducers/surveySlice';
import SurveyListItem from './SurveyListItem';

//gestire showPos e modificare w.s. per avere pos name
const SurveyList = ({pos_id, template_id, area_id, showPos, showHidden}) => {
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);

    const sorting = useSelector((state) => state.surveyReducer.sorting);
    const filters = useSelector((state) => state.surveyReducer.filters);
    const term = useSelector((state) => state.surveyReducer.term);
    const surveyList = useSelector((state) => selectSurveyByAreaId(state, area_id))
    const showMore = useSelector((state) => state.surveyReducer.showMore );
    const fromDate = useSelector((state) => state.posAnalyticsReducer.fromDate);
    const toDate = useSelector((state) => state.posAnalyticsReducer.toDate);

    const [idSort] = useState(sorting.id);
    const [closedAtSort] = useState(sorting.closed_at);
    const [userSort] = useState(sorting.user);
    const [templateSort] = useState(sorting.template);
    const [avgScoreSort] = useState(sorting.avg_score);

    const dispatch = useDispatch();

    const loadMore = (p) => {
        if(!loading) {
            setLoading(true);

            let newSorting = {
                id: idSort,
                closed_at: closedAtSort,
                user: userSort,
                template: templateSort,
                avg_score: avgScoreSort,
            }

            fromDate.set({hour:0,minute:0,second:0,millisecond:0})
            toDate.set({hour:23,minute:59,second:59,millisecond:999})

            let from = fromDate ? moment.tz(fromDate.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'UTC').format() : null;
            let to = toDate ? moment.tz(toDate.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'UTC').format() : null;

            let filters = {
                pos_id: pos_id ? parseInt(pos_id) : null,
                template_id: template_id ? parseInt(template_id) : null,
                area_id: area_id ? parseInt(area_id) : null,
                fromDate: from,
                toDate: to,
                showHidden: showHidden
            }
            dispatch(setSorting(newSorting));
            dispatch(setFilters(filters));
            dispatch(removeAllSurvey())
            dispatch(surveyApi.fetchAll( {page: p, term: term, sorting: newSorting, filters: filters} ));
        }
    }

    useEffect(() => {
        setPage(0);
        loadMore(0);
    }, [dispatch, term, idSort, closedAtSort, userSort, templateSort, avgScoreSort, area_id, template_id, fromDate, toDate, showHidden]);

    useEffect( () => {
        // if(surveyList.length > 0 && showMore) setPage(page+1);
        setLoading(false);
    }, [surveyList])

    return (
        <Card>
            <CardBody>
                <div>
                { 
                    surveyList.length > 0
                    ?   <>
                            <InfiniteScroll
                                element="div"
                                loadMore={ () => { loadMore(page); }}
                                hasMore={showMore}
                                loader={<div className="loader" key={0}></div>}
                                initialLoad={false}
                                useWindow={false}
                            >
                                <Table responsive hover style={{marginBottom: 0}}>
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Area</th>
                                            <th>Assistente di rete</th>
                                            <th>Data creazione</th>
                                            <th>Data aggiornamento</th>
                                            <th>Data chiusura</th>
                                            <th>Punteggio</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {surveyList.map((survey) => (
                                            <SurveyListItem survey={survey} key={survey.id} />
                                        ))}
                                    </tbody>
                                </Table>
                            </InfiniteScroll> 
                        </>
                    :   <div>
                            -
                        </div> 
                }
                    
                </div>

            </CardBody>
        </Card>
    );
}

export default SurveyList;
